import React from 'react';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
    Button,
    Checkbox,
    Chip,
    Dialog,
    DialogActions,
    DialogContent,
    Divider,
    Fab,
    Grid,
    IconButton,
    Link,
    List,
    ListItem,
    ListItemText,
    Paper,
    Radio,
    Tab,
    Tabs,
    TextField,
    Typography,
    withStyles,
} from "@material-ui/core";
import { Add, Close, Delete, NavigateBefore } from '@material-ui/icons'
import SwipeableViews from "react-swipeable-views";
import withWidth from '@material-ui/core/withWidth';
import {
    receive_devices,
    receive_issues,
    receive_user_devices,
    add_device_to_repair
} from "../../../apis/redux/fetchActions";
import APIService from '../../../apis/amplify/APIService';
import DeviceItem from "../../../components/DeviceItem";
import DeviceIcon from "../../../components/DeviceIcon";
import DialogTitleContainer, { Title, TitleButton } from "../../../components/DialogTitleContainer";
import SectionTitleContainer, { SectionRight, SectionTitle } from '../../../components/SectionTitleContainer';
import Adaptable from '../../../components/Adaptable';
import If from '../../../components/If';
import Loading, { LoadingText, Progress } from '../../../components/Loading';
import { formatCurrency } from '../../../util/formatters';
import { styles } from './styles';

const buildQueryDevicesByModel = (() => {

    let _devicesById = null;
    let _indexedCollection = null;

    return devices => {
        function getDevicesById(devices) {
            return devices.reduce((res, d) => {
                res.ids.push(d.id);
                res.devicesById[d.id] = d;
                return res;
            }, { ids: [], devicesById: {} });
        }

        function buildDevicesByModelMap({ ids, devicesById }) {
            const indexedByModel = { '': ids };
            ids.forEach(id => {
                const { model_numbers } = devicesById[id];
                if (model_numbers) {
                    model_numbers.forEach(model => {
                        const lowerModel = (model || '').toLowerCase();
                        for (let i = 1; i <= lowerModel.length; i++) {
                            const sub = lowerModel.slice(0, i);
                            indexedByModel[sub] = indexedByModel[sub] || [];
                            if (indexedByModel[sub].indexOf(id) === -1) {
                                indexedByModel[sub].push(id);
                            }
                        }
                    });
                }
            });
            return indexedByModel;
        }

        return model => {
            model = (model || '').toLowerCase();
            if (!_indexedCollection) {
                const { ids, devicesById } = getDevicesById(devices);
                _devicesById = devicesById;
                _indexedCollection = buildDevicesByModelMap({ ids, devicesById });
            }
            return (_indexedCollection[model] || []).map(id => _devicesById[id]);
        };
    };
})();

const noopDevByModelIndexed = () => ([]);

class AddDevicesStep extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loadingDevices: false,
            loadingIssues: false,
            addDevicesInformativeDialogOpen: false,
            addDeviceDialogOpen: false,
            addOtherIssuesDialogOpen: false,
            tabIndex: 0,
            pendingAddDevice: null,
            otherIssuesToDevice: '',
            wizardStep: 0,
            wizardStepTitle: 'SELECT DEVICE',
            wizardNextButtonText: 'Next',
            hasDevices: 0,
            columnsFactor: (props.width === 'xs') ? 6 : 3,
            modelFilter: '',
        };

        this._selectDevicesByModel = noopDevByModelIndexed;

        this.onCloseAddDeviceDialog = this.onCloseAddDeviceDialog.bind(this);
    }

    componentDidMount() {
        const { devices } = this.props;
        if (devices.length === 0) {
            this.loadDevices();
        }
    }

    componentWillReceiveProps(nextProps) {
        const { width } = nextProps;
        if (width === 'xs') {
            this.setState({ columnsFactor: 6 })
        }
        else {
            this.setState({ columnsFactor: 3 })
        }
    }

    async loadDevices() {
        this.setState({ loadingDevices: true });
        const { ok, data } = await APIService.getDevices();
        this.setState({ loadingDevices: false });
        if (ok)
            this.props.actions.receiveDevices(data);
    };

    selectIssue = issueId => () => {
        const { issues } = this.props;
        if (!this.state.pendingAddDevice.issues.some(issue => issue.id === issueId)) {
            this.setState((prevState) => {
                const pendingAdd = prevState.pendingAddDevice;
                const step1 = issues.filter(item => item.id === issueId)[0];
                pendingAdd.issues.push(step1);
                return { pendingAddDevice: pendingAdd };
            });
        }
        else {
            this.setState((prevState) => {
                let device = prevState.pendingAddDevice;
                device.issues = device.issues.filter(item => item.id !== issueId);
                return { pendingAddDevice: device }
            });
        }
    };

    onRemoveIssue = args => {
        const { appointmentData, actions } = this.props;
        let devices = appointmentData.items;
        const device = devices.filter(item => item.innerId === args.deviceInnerId)[0];
        device.issues = device.issues.filter(item => item.id !== args.issueId);
        actions.receiveUserDevices(devices);
        this.forceUpdate();
    };

    addOtherIssue = async args => {
        const device = this.props.appointmentData.items.filter(device => device.innerId === args.innerId)[0];
        this.setState({
            otherIssuesToDevice: device.title,
            pendingAddDevice: device,
            addOtherIssuesDialogOpen: true,
            loadingIssues: true
        });
        const { ok, data } = await APIService.getIssuesByDevice(args.id);
        if (ok) {
            this.props.actions.receiveIssues(data);
        } else {
            this.setState({ addDeviceIssuesDialogOpen: false });
        }
        this.setState({ loadingIssues: false, });
    };

    setDeviceColor = colorId => {
        const { devices } = this.props;
        this.setState(prevState => {
            const device = devices.filter(item => item.id === prevState.pendingAddDevice.id)[0];
            let pendingDevice = prevState.pendingAddDevice;
            pendingDevice.color = device.colors.filter(color => color.id === colorId)[0];
            return { pendingAddDevice: pendingDevice }
        });
        this.wizardNext();
    };

    getDeviceColorAdded = id => {
        if (this.state.pendingAddDevice !== null) {
            if (this.state.pendingAddDevice.color === null)
                return false;
            return this.state.pendingAddDevice.color.id === id
        }
        return false;
    };

    selectDevice = id => {
        const { devices } = this.props;
        const device = devices.filter(item => item.id === id)[0];
        if (this.state.pendingAddDevice !== null) {
            if (this.state.pendingAddDevice.id === device.id) {
                this.setState({ wizardStep: 1, wizardStepTitle: this.state.pendingAddDevice.title + ' color' });
            } else {
                let pendingDevice = {
                    innerId: null,
                    id: id,
                    title: device.title,
                    color: null,
                    issues: [],
                    type: device.type
                };
                this.setState({
                    pendingAddDevice: pendingDevice,
                    wizardStep: 1,
                    wizardStepTitle: pendingDevice.title + ' color'
                });
            }
        }
        else {
            let pendingDevice = {
                innerId: null,
                id: id,
                title: device.title,
                color: null,
                issues: [],
                type: device.type
            };
            this.setState({
                pendingAddDevice: pendingDevice,
                wizardStep: 1,
                wizardStepTitle: pendingDevice.title + ' color'
            });
        }
    };

    showAddDialog() {
        this.setState({ addDeviceDialogOpen: true, pendingAddDevice: null });
    };

    onDeviceSelectionTabChange = (_, tabIndex) => {
        if (tabIndex === 3 && this._selectDevicesByModel === noopDevByModelIndexed) {
            this._selectDevicesByModel = buildQueryDevicesByModel(this.props.devices);
        }
        this.setState({ tabIndex });
    };

    /**
     * Remove Device of User Devices List
     * @param id Id of device to remove
     */
    removeDevice = id => {
        const userDevices = this.props.appointmentData.items.filter(item => item.innerId !== id);
        this.props.actions.receiveUserDevices(userDevices);
        this.setState((prevState) => {
            return { hasDevices: prevState.hasDevices - 1 }
        })
    };

    async wizardNext() {
        if (this.state.wizardStep === 1) {
            this.setState({
                wizardStepTitle: this.state.pendingAddDevice.title + ' issues',
                wizardNextButtonText: 'Add Device',
                wizardStep: 2
            });
            if (this.props.issues.length === 0) {
                this.setState({ loadingIssues: true, });
                const { ok, data } = await APIService.getIssuesByDevice(this.state.pendingAddDevice.id);
                this.setState({ loadingIssues: false, });
                if (ok) {
                    this.props.actions.receiveIssues(data);
                } else {
                    this.setState({ addDeviceIssuesDialogOpen: false, gettingIssuesLoadingDialogOpen: false });
                }
            }
        } else if (this.state.wizardStep === 2) {
            let step = this.state.pendingAddDevice;
            step.innerId = Date.now();
            this.props.actions.addDeviceToRepair(this.state.pendingAddDevice);
            this.props.actions.receiveIssues(null);
            this.setState((prevState) => {
                return {
                    addDeviceDialogOpen: false,
                    wizardStep: 0,
                    wizardStepTitle: 'SELECT DEVICE',
                    hasDevices: prevState.hasDevices + 1,
                    wizardNextButtonText: 'NEXT',
                    pendingAddDevice: null
                }
            })
        }
    }

    onWizardBack() {
        if (this.state.wizardStep === 1) {
            this.setState({ wizardStepTitle: 'SELECT DEVICE' });
        } else if (this.state.wizardStep === 2) {
            this.setState({
                wizardNextButtonText: 'NEXT',
                wizardStepTitle: this.state.pendingAddDevice.title + ' color'
            });
        }
        this.setState(prevState => ({ wizardStep: prevState.wizardStep - 1 }));
    }

    cantNext() {
        if (this.state.wizardStep === 1) {
            if (this.state.pendingAddDevice !== null) {
                return this.state.pendingAddDevice.color === null;
            }
        }
        else if (this.state.wizardStep === 2) {
            if (this.state.pendingAddDevice !== null) {
                return this.state.pendingAddDevice.issues.length === 0;
            }
        }
    }

    onCloseAddDeviceDialog() {
        this.setState({
            addDeviceDialogOpen: false,
            wizardStep: 0,
            pendingAddDevice: null,
            wizardStepTitle: 'SELECT DEVICE'
        });
        this.props.actions.receiveIssues(null);
    }

    getTotal() {
        return this.props.appointmentData.items.reduce((sum, device) => sum + device.issues.reduce((issueSum, issue) => issueSum + issue.price, 0), 0);
    }

    onCloseOtherIssueDialog() {
        this.setState({ addOtherIssuesDialogOpen: false });
        this.props.actions.receiveIssues(null);
    }

    renderIssuesFor = deviceId => {
        const { classes, appointmentData } = this.props;
        const device = appointmentData.items.find(device => device.innerId === deviceId);
        if (device) {
            const canRemove = device.issues.length > 1;
            return device.issues.map(issue => {

                return (
                    <Chip key={issue.id} className={classes.issueChip}
                          onDelete={canRemove ? this.onRemoveIssue.bind(this, {
                              deviceInnerId: deviceId,
                              issueId: issue.id
                          }) : null}
                          label={<span><span
                              style={{ fontWeight: 'initial' }}>{issue.title}</span> - {formatCurrency(issue.price)}</span>}
                    />
                )
            });
        }
    };

    renderColorsFor = deviceId => {
        const { devices } = this.props;
        if (deviceId) {
            let deviceToAdd = devices.find(item => item.id === deviceId);
            if (deviceToAdd) {
                return deviceToAdd.colors.map((color) => (
                        <ListItem onClick={this.setDeviceColor.bind(this, color.id)} button value={color.id}
                                  key={color.id}>
                            <Radio color='primary' checked={this.getDeviceColorAdded(color.id)} tabIndex={-1}
                                   disableRipple/>
                            <svg xmlns="http://www.w3.org/2000/svg" height="32" width="32" viewBox="0 0 32 32">
                                <g>
                                    <path id="path1" transform="rotate(0,16,16) translate(1.6,1.6) scale(0.9,0.9)  "
                                          fill={color.code}
                                          d="M16,0C24.837036,0 32,7.1629944 32,16 32,24.836975 24.837036,32 16,32 7.1630249,32 0,24.836975 0,16 0,7.1629944 7.1630249,0 16,0z"/>
                                </g>
                            </svg>
                            <ListItemText primary={color.name}/>
                        </ListItem>
                    )
                )
            }
        }
    };

    renderIssues = () => {
        const { issues } = this.props;
        return issues.map((item) => {
            return (
                <ListItem onClick={this.selectIssue(item.id)} value={item.id} key={item.id} role={undefined} dense
                          button>
                    <Checkbox
                        checked={(this.state.pendingAddDevice === null) ? false : this.state.pendingAddDevice.issues.filter(i => i.id === item.id).length > 0}
                        color='primary' tabIndex={-1} disableRipple/>
                    <ListItemText primary={<Typography variant={"subtitle1"}>{item.title}</Typography>}
                                  secondary={'Price: ' + formatCurrency(item.price)}/>
                </ListItem>
            )
        });
    };

    render() {
        const { classes, devices, appointmentData } = this.props;
        const { pendingAddDevice, modelFilter, columnsFactor, wizardStep, loadingDevices, loadingIssues } = this.state;
        return (
            <div>
                <Dialog open={this.state.addDeviceDialogOpen}
                        className={classes.addDeviceDialog}
                        PaperProps={{ className: classes.modalDialog }}
                        disableBackdropClick={false}
                        onBackdropClick={this.onCloseAddDeviceDialog}>
                    <DialogTitleContainer>
                        <TitleButton onClick={this.onWizardBack.bind(this)}
                                     style={{ visibility: (wizardStep === 0) ? 'hidden' : 'visible', }}>
                            <NavigateBefore color='primary'/>
                        </TitleButton>
                        <Title>{this.state.wizardStepTitle}</Title>
                        <TitleButton className="closeButton" location="right" onClick={this.onCloseAddDeviceDialog}>
                            <Close/>
                        </TitleButton>
                    </DialogTitleContainer>
                    <DialogContent className={`dialogContent ${!wizardStep ? 'topSeparation' : ''}`}>
                        <If as={Loading}
                            condition={loadingDevices || loadingIssues}
                            style={{ marginTop: wizardStep === 2 ? 65 : 0 }}>
                            <Progress/><LoadingText>{`Loading ${loadingDevices ? 'devices' : 'issues'}...`}</LoadingText>
                        </If>
                        <If condition={wizardStep === 0 && devices.length > 0 && !loadingDevices}>
                            <Tabs style={{ marginTop: '5px' }}
                                  value={this.state.tabIndex}
                                  onChange={this.onDeviceSelectionTabChange}
                                  className="tabContainer"
                                  indicatorColor="primary"
                                  textColor="primary"
                                  variant="fullWidth">
                                <Tab value={0} label="iPhone"/>
                                <Tab value={1} label="iPad"/>
                                <Tab value={2} label="Samsung"/>
                                <Tab value={3} label="By Model"/>
                            </Tabs>
                        </If>
                        <SwipeableViews index={wizardStep}>
                            <SwipeableViews index={this.state.tabIndex} style={{ marginTop: '10px', }}>
                                <Grid container alignContent='center' alignItems='center'>
                                    {devices.filter(item => item.type === 'iPhone').map(device => (
                                        <Grid key={device.id} item xs={this.state.columnsFactor}
                                              sm={this.state.columnsFactor}
                                              md={this.state.columnsFactor} xl={this.state.columnsFactor}
                                              lg={this.state.columnsFactor}
                                              className={classes.grid}>
                                            <DeviceItem device={device}
                                                        selectDevice={this.selectDevice}
                                                        isSelected={(this.state.pendingAddDevice === null) ? false : this.state.pendingAddDevice.id === device.id}/>
                                        </Grid>
                                    ))}
                                </Grid>
                                <Grid container>
                                    {devices.filter(item => item.type === 'iPad').map(device => (
                                        <Grid key={device.id} item xs={this.state.columnsFactor}
                                              sm={this.state.columnsFactor}
                                              md={this.state.columnsFactor} xl={this.state.columnsFactor}
                                              lg={this.state.columnsFactor}
                                              className={classes.grid}>
                                            <DeviceItem device={device} selectDevice={this.selectDevice}
                                                        isIphone={false}
                                                        isSelected={(this.state.pendingAddDevice === null) ? false : this.state.pendingAddDevice.id === device.id}/>
                                        </Grid>
                                    ))
                                    }
                                </Grid>
                                <Grid container>
                                    {devices.filter(item => item.type === 'Samsung').map(device => (
                                        <Grid key={device.id} item xs={this.state.columnsFactor}
                                              sm={this.state.columnsFactor}
                                              md={this.state.columnsFactor} xl={this.state.columnsFactor}
                                              lg={this.state.columnsFactor}
                                              className={classes.grid}>
                                            <DeviceItem device={device} selectDevice={this.selectDevice}
                                                        isIphone={false}
                                                        isSelected={(this.state.pendingAddDevice === null) ? false : this.state.pendingAddDevice.id === device.id}/>
                                        </Grid>
                                    ))
                                    }
                                </Grid>
                                <div className={classes.devicesByModelContainer}>
                                    <div className="modelInputContainer">
                                        <TextField autoFocus label="Model" className="modelInput"
                                                   value={modelFilter}
                                                   onChange={e => this.setState({ modelFilter: e.target.value })}/>
                                        <p className="modelLocationTip">
                                            You can find your device model in the back side of your device
                                            like <strong>A####</strong>.
                                        </p>
                                    </div>
                                    <Grid container alignContent='center' alignItems='center'>
                                        {this._selectDevicesByModel(modelFilter).map(device => (
                                            <Grid key={device.id} item xs={columnsFactor}
                                                  sm={columnsFactor} md={columnsFactor} xl={columnsFactor}
                                                  lg={columnsFactor} className={classes.grid}>
                                                <DeviceItem device={device}
                                                            selectDevice={this.selectDevice}
                                                            isSelected={(pendingAddDevice === null) ? false : pendingAddDevice.id === device.id}/>
                                            </Grid>
                                        ))}
                                    </Grid>
                                </div>
                            </SwipeableViews>

                            <If as={List} condition={wizardStep === 1}>
                                {this.renderColorsFor(pendingAddDevice && pendingAddDevice.id)}
                            </If>
                            <If as={List} condition={wizardStep === 2}>
                                {this.renderIssues()}
                            </If>
                        </SwipeableViews>

                    </DialogContent>
                    <DialogActions>
                        <If condition={wizardStep !== 0 && !this.state.loadingIssues}>
                            <Button onClick={this.wizardNext.bind(this)}
                                    disabled={this.cantNext()}
                                    fullWidth
                                    style={{ background: (wizardStep === 1) && 'none' }}
                                    variant={(wizardStep === 2) ? 'contained' : 'outlined'}
                                    color={(wizardStep === 2) ? 'secondary' : 'primary'}
                                    className={classes.submit}>
                                {this.state.wizardNextButtonText}
                            </Button>
                        </If>
                    </DialogActions>
                </Dialog>

                <Dialog open={this.state.addOtherIssuesDialogOpen}
                        disableBackdropClick={false}
                        PaperProps={{ className: classes.modalDialog }}
                        onBackdropClick={this.onCloseOtherIssueDialog.bind(this)}>
                    <DialogTitleContainer>
                        <Title>{this.state.otherIssuesToDevice} issues</Title>
                        <TitleButton onClick={this.onCloseOtherIssueDialog.bind(this)} location="right">
                            <Close/>
                        </TitleButton>
                    </DialogTitleContainer>
                    <DialogContent>
                        <If as={Loading}
                            condition={loadingIssues}
                            style={{ marginTop: 65 }}>
                            <Progress/><LoadingText>Loading issues...</LoadingText>
                        </If>
                        <If condition={!loadingIssues}>
                            <List>
                                {this.renderIssues()}
                            </List>
                        </If>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => {
                            this.setState({ addOtherIssuesDialogOpen: false })
                        }}
                                fullWidth
                                variant="contained"
                                color="secondary"
                                className={classes.submit}>
                            Close
                        </Button>
                    </DialogActions>
                </Dialog>

                <Adaptable as={SectionTitleContainer} hideFromSmallDown>
                    <SectionTitle>
                        Devices to Repair {this.getTotal() === 0 ? '' : ` (${formatCurrency(this.getTotal())})`}
                    </SectionTitle>
                    <SectionRight onClick={this.showAddDialog.bind(this)} color='secondary' underline='hover'>
                        ADD DEVICE
                    </SectionRight>
                </Adaptable>

                {
                    (appointmentData.items.length === 0) ?
                        (
                            <div style={{ width: '80%', marginLeft: 'auto', marginRight: 'auto' }}>
                                <Typography className={classes.emptyTypography} variant='subtitle1'
                                            align="center">
                                    Please add the devices you want to repair to create an appointment
                                </Typography>
                            </div>
                        )
                        :
                        (
                            <div className={classes.listContainer}>
                                <Divider className={classes.endListDivider}/>
                                {this.props.appointmentData.items.map((device, index) => (
                                    <Paper elevation={0} key={device.id} className={classes.itemsPaper}
                                           style={{ marginBottom: (index < this.props.appointmentData.items.length - 1) && '2px' }}>
                                        <div className={classes.itemMainDiv}>
                                            <div className={classes.itemHeader}>
                                                <DeviceIcon deviceName={device.title}/>
                                                <Typography color='primary' variant="subtitle1"
                                                            noWrap={true}
                                                            className={classes.itemTitle}>
                                                    {device.title}
                                                </Typography>
                                                <Paper elevation={0} className={classes.colorPaper}>
                                                    <svg xmlns="http://www.w3.org/2000/svg" height="17"
                                                         width="17" viewBox="0 0 17 17">
                                                        <g>
                                                            <path id="path1"
                                                                  transform="rotate(0,8.5,8.5) translate(0,0) scale(0.53125,0.53125)  "
                                                                  fill={device.color.code}
                                                                  d="M16,0C24.837036,0 32,7.1629944 32,16 32,24.836975 24.837036,32 16,32 7.1630249,32 0,24.836975 0,16 0,7.1629944 7.1630249,0 16,0z"/>
                                                        </g>
                                                    </svg>
                                                    <Typography variant="subtitle2" align='center'
                                                                noWrap={true}
                                                                className={classes.colorName}>
                                                        {device.color.name}
                                                    </Typography>
                                                </Paper>
                                                <div className={classes.separator}/>
                                                <div className={classes.deleteButtonMovil}>
                                                            <span className={classes.buttonCard}>
                                                            <IconButton
                                                                onClick={this.removeDevice.bind(this, device.innerId)}
                                                                style={{ padding: '5px' }}>
                                                                <Delete color='primary'/>
                                                            </IconButton>
                                                            </span>
                                                </div>
                                            </div>
                                            <div className={classes.issuesDesktop}>
                                                <Typography gutterBottom variant="subtitle2" align='left'>
                                                    Issues
                                                </Typography>
                                                {this.renderIssuesFor(device.innerId)}
                                                <Link
                                                    className={classes.otherChip}
                                                    key={-1}
                                                    underline='hover' color='secondary'
                                                    onClick={this.addOtherIssue.bind(this, {
                                                        innerId: device.innerId,
                                                        id: device.id
                                                    })}>
                                                    ADD ISSUE
                                                </Link>
                                            </div>
                                            <div className={classes.deleteButtonDesktop}>
                                                        <span className={classes.buttonCard}>
                                                            <IconButton
                                                                onClick={this.removeDevice.bind(this, device.innerId)}>
                                                            <svg xmlns="http://www.w3.org/2000/svg" height="18"
                                                                 width="18" viewBox="0 0 18 18">
  <g>
    <path id="path1"
          transform="rotate(0,9,9) translate(2.25000563263423,0) scale(0.562499530613814,0.562499530613814)  "
          fill="#000000"
          d="M15.000001,8.0000272L17,8.0000272 17,27.000028 15.000001,27.000028z M11.000001,8.0000272L13.000001,8.0000272 13.000001,27.000028 11.000001,27.000028z M7.0000005,8.0000272L9.000001,8.0000272 9.000001,27.000028 7.0000005,27.000028z M3.0790101,5.0000274L4.9959994,29.922999 19.000006,30.000026 20.918949,5.0000274z M13.771989,1.9959999L10.198989,2.0000001C10.158989,2.025,9.9989892,2.241,9.9989892,2.6000001L9.9989892,3.0000258 13.998989,3.0000258 13.998989,2.6000001C13.998989,2.241,13.838988,2.025,13.771989,1.9959999z M10.198989,0L13.798988,0C15.031989,0,15.998989,1.142,15.998989,2.6000001L15.998989,3.0000258 23.07898,3.0000258 24,3.0000272 24,5.0000274 22.925121,5.0000274 20.995976,30.076991C20.999027,31.102992,20.100956,32.000026,18.999029,32.000026L4.9990512,32.000026C3.8960255,32.000026,2.9990543,31.102992,2.999054,30.000026L1.073059,5.0000274 0,5.0000274 0,3.0000272 0.91897895,3.0000272 7.9989887,3.0000258 7.9989887,2.6000001C7.9989887,1.142,8.9659892,0,10.198989,0z"/>
  </g>
</svg>
                                                        </IconButton>
                                                        </span>
                                            </div>
                                        </div>
                                    </Paper>
                                ))
                                }
                                <Divider className={classes.endListDivider}/>
                            </div>
                        )
                }

                <Fab onClick={this.showAddDialog.bind(this)}
                     size='small' color='secondary'
                     className={classes.addDialogFabButton}>
                    <Add/>
                </Fab>

            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        appointmentData: state.appointmentData,
        devices: state.devices || [],
        issues: state.issues || [],
    }
};

const mapDispatchToProps = dispatch => {
    return {
        actions: bindActionCreators({
            receiveDevices: receive_devices,
            receiveUserDevices: receive_user_devices,
            receiveIssues: receive_issues,
            addDeviceToRepair: add_device_to_repair
        }, dispatch)
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(withWidth()(withStyles(styles, { withTheme: true })(AddDevicesStep)));
